import React, { useMemo } from "react";
import { Accordion, Card, Col, Row } from "react-bootstrap";
// import { langTypeMap } from "../../../../../shared/Data/langTypeMap";
import { CAT, MAS, REP_SEC, SUB } from "../../../../../shared/Data/typeDirs";

// export function CategoryMenu({ source, subcategoryClicked = (subcat, section) => { console.log('clicked subcat', section, subcat) } }) {
//   const { [REP_SEC]: reportSections } = source
//   const [selectedSection, setSelectedSection] = useState(reportSections[0].getDisplayText())
//   function generateMenu() {
//     let cards = []
//     for (let section of reportSections) {

//       cards.push(
//         <Card>
//           <Accordion.Toggle as={Card.Header} eventKey={section._id}>{section.getDisplayText()}</Accordion.Toggle>
//           <Accordion.Collapse eventKey={section._id}>
//             <Card.Body className="report-category-menu-card-body">
//               <Accordion>
//                 {source[MAS].map(mastercategory => createMasterCategoryAccordion(mastercategory, section._id))}
//               </Accordion>
//             </Card.Body>
//           </Accordion.Collapse>
//         </Card>
//       )

//     }


//     console.log('made these cards', cards)
//     return (
//       <div>
//         <Dropdown>
//           <Dropdown.Toggle>{selectedSection}</Dropdown.Toggle>
//           <Dropdown.Menu>
//             {reportSections.map(sec => <Dropdown.Item eventKey={sec.getDisplayText()}>{sec.getDisplayText()}</Dropdown.Item>)}
//           </Dropdown.Menu>
//         </Dropdown>
//         {source[MAS].map(mastercategory => createMasterCategoryAccordion(mastercategory, selectedSection))}

//       </div>
//     )
//   }

//   function createMasterCategoryAccordion(mastercategory, section) {
//     return (
//       <Card>
//         <Accordion.Toggle as={Card.Header} eventKey={mastercategory._id}>
//           {`${mastercategory.fullNumber}: ${mastercategory.content}`}
//         </Accordion.Toggle>
//         <Accordion.Collapse eventKey={mastercategory._id}>
//           <Card.Body className="report-category-menu-card-body">
//             <Accordion>
//               {mapThroughChildren(MAS, mastercategory._id, (category) => {
//                 return (
//                   <Card>
//                     <Accordion.Toggle as={Card.Header} eventKey={category._id}>
//                       {`${category.fullNumber}: ${category.content}`}
//                     </Accordion.Toggle>
//                     <Accordion.Collapse eventKey={category._id}>
//                       <Card.Body className="report-category-menu-card-body">
//                         {mapThroughChildren(CAT, category._id, (subcategory) => {
//                           return (
//                             <Dropdown.Item onClick={() => {
//                               document.body.click()
//                               subcategoryClicked(subcategory, section)
//                             }}>
//                               {`${subcategory.fullNumber}: ${subcategory.content}`}
//                             </Dropdown.Item>
//                           )
//                         })}
//                       </Card.Body>
//                     </Accordion.Collapse>
//                   </Card>
//                 )
//               })}
//             </Accordion>
//           </Card.Body>
//         </Accordion.Collapse>
//       </Card>
//     )
//   }

//   function mapThroughChildren(type, _id, callback) {
//     const [res] = langTypeMap[type].getChildTypes().map(childType => source[childType].filter(childItem => childItem[`_${type}`] === _id).map(childItem => callback(childItem)))
//     console.log('mapped children and got this', res)
//     return res
//   }

//   const menu = useMemo(() => generateMenu(), [source])

//   return (
//     <Accordion>
//       {menu}
//     </Accordion>
//   )
// }




function AccordionItem({ title, children, eventKey, headerClass }) {
  return (
    <Card>
      <Accordion.Toggle as={Card.Header} className={headerClass} eventKey={eventKey}>
        {title}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>
          {children}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  )
}

function SectionItem({ title, onClick, className }) {

  return (
    <Card onClick={onClick}>
      <Card.Header className={className}>{title}</Card.Header>
    </Card>
  )
}

export function CategoryMenu({ source, onClick, subcategoryClicked, menuState }) {
  // const [activeKey, setActiveKey] = useState(false)
  // const [overlayTarget, setOverlayTarget] = useState(false)

  let sectionList = source[REP_SEC].map(reportSection => (
    <SectionItem className={menuState[REP_SEC] === reportSection._id ? 'active-section' : ''} title={reportSection.getDisplayText()} onClick={evt => {
      console.log('clicked section', evt.target)
      onClick(REP_SEC, reportSection._id)

    }} />
  ))
  let menu = useMemo(() => (
    <Accordion activeKey={menuState[MAS]} onSelect={evt => {
      console.log('root select callback', evt)
      onClick(MAS, evt)
    }}>
      {
        source[MAS].map(mastercategory => {
          return (
            <AccordionItem
              title={mastercategory.getDisplayText()}
              eventKey={mastercategory._id}
              headerClass={menuState[MAS] === mastercategory._id ? 'active-section' : ''}
            >
              <Accordion activeKey={menuState[CAT]} onSelect={evt => {
                console.log('second select callback', evt)
                onClick(CAT, evt)
              }}>
                {source[CAT].filter(category => category._mastercategories === mastercategory._id).map(category => (
                  <AccordionItem
                    title={category.getDisplayText()}
                    eventKey={`${category._id}`}
                    headerClass={menuState[CAT] === category._id ? 'active-section' : ''}
                  >
                    {source[SUB].filter(subcategory => subcategory._categories === category._id).map(subcategory => (
                      <Card.Header
                        className={menuState[SUB] === subcategory._id ? 'active-section' : ''}
                        onClick={(evt) => {
                          console.log('what is this', evt)
                          // document.body.click()
                          onClick(SUB, subcategory._id)
                        }}>
                        {`${subcategory.fullNumber}: ${subcategory.content}`}
                      </Card.Header>
                    ))}
                  </AccordionItem>
                ))}
              </Accordion>
            </AccordionItem>
          )
        })
      }
    </Accordion>
  ), [menuState, onClick, source])
  return (
    <Row className="g-0 category-menu-container-row">
      <Col>
        {sectionList}
      </Col>
      <Col className="category-menu-col">
        {menu}
      </Col>
    </Row>
  )
}